import { editionIds, productIds } from '../../globals';
import { Product } from './product';

export function isA2pSubmitRestricted(products: Product[]): boolean {
  const list = products || [];

  const hasRMPremium = list.some(
    (p) => p.productId === productIds.reputationManagement && p.editionId === editionIds.reputationManagementPremium,
  );

  const hasConvAIPremiumOrPro = list.some(
    (p) =>
      p.productId === productIds.conversationAI &&
      (p.editionId === editionIds.conversationAIPremium || p.editionId === editionIds.conversationAIPro) &&
      !p.isTrial,
  );

  const hasInboxPro = list.some((p) => p.productId === productIds.inboxPro);
  const hasInboxSms = list.some((p) => p.productId === productIds.inboxSms);
  const hasCampaignsPro = list.some((p) => p.productId === productIds.campaignsPro);
  const hasCustomerVoice = list.some((p) => p.productId === productIds.customerVoice);

  return !hasRMPremium && !hasConvAIPremiumOrPro && !hasInboxPro && !hasInboxSms && !hasCampaignsPro && !hasCustomerVoice;
}
